import { useState, useEffect, useRef } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };


const IMG = {
  sunny: "/images/characters/sunny.webp",
  logo: "/images/logo.webp",
};

const reviews = [
  { text: "Lovely little class! Full of fun and energy which is perfect for my lively two year old! Sophie and Brittany put lots of thought into the sessions and the children seem to really engage and enjoy it! Lots of fun, laughter and dancing! It's a big hit with my daughter.", author: "Chantelle", stars: 5, color: C.pink },
  { text: "My Grandaughter was so shy, but Sophie spoke to her as she was doing the dancing, and she was joining in a few of the dances. The props were fun for the kids to dance with. My Josie wants to go next week, so you've done a good job in making it fun for the kids! Well done Funky Bunch teachers.", author: "Victoria", stars: 5, color: C.yellow },
  { text: "Attended the first week class and my little girl loved it and is asking to go back already! Sophie and Brittany have thought of all the small details for the children and have put so much effort in for them and the dances and music and they are both really engaging with the kids! Can't wait to return next week!", author: "Liz", stars: 5, color: C.mint },
];

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Reviews" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Reviews" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

/* ═══ CAROUSEL ═══ */
const ReviewCarousel = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
      checkScroll();
      return () => el.removeEventListener("scroll", checkScroll);
    }
  }, []);

  return (
    <div style={{ position: "relative" }}>
      {/* Scroll container */}
      <div
        ref={scrollRef}
        style={{
          display: "flex",
          gap: 20,
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          padding: "8px 4px 16px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <style>{`
          .review-scroll::-webkit-scrollbar { display: none; }
        `}</style>
        {reviews.map((r, i) => (
          <div
            key={i}
            style={{
              flex: "0 0 300px",
              scrollSnapAlign: "start",
              background: r.color + "12",
              borderRadius: 24,
              padding: "28px 24px",
              border: `2px solid ${r.color}30`,
              position: "relative",
            }}
          >
            {/* Big quote mark */}
            <div style={{
              position: "absolute", top: 12, left: 18,
              fontFamily: heading, fontSize: 48, fontWeight: 800,
              color: r.color + "30", lineHeight: 1,
            }}>"</div>

            <div style={{ fontSize: 16, color: C.yellow, marginBottom: 12 }}>
              {"★".repeat(r.stars)}
            </div>
            <p style={{
              fontFamily: body, fontSize: 14, color: C.ink,
              lineHeight: 1.7, fontStyle: "italic",
              marginBottom: 16, minHeight: 100,
            }}>
              "{r.text}"
            </p>
            <div style={{
              fontFamily: heading, fontWeight: 700, fontSize: 12,
              color: r.color,
            }}>
              — {r.author}
            </div>
          </div>
        ))}
      </div>

      {/* Arrow buttons */}
      {canScrollLeft && (
        <div
          onClick={() => scroll(-1)}
          style={{
            position: "absolute", left: -16, top: "50%",
            transform: "translateY(-50%)",
            width: 40, height: 40, borderRadius: "50%",
            background: "#fff", border: `2px solid ${C.yellow}44`,
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", fontSize: 20, color: C.ink,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            zIndex: 5,
          }}
        >‹</div>
      )}
      {canScrollRight && (
        <div
          onClick={() => scroll(1)}
          style={{
            position: "absolute", right: -16, top: "50%",
            transform: "translateY(-50%)",
            width: 40, height: 40, borderRadius: "50%",
            background: "#fff", border: `2px solid ${C.yellow}44`,
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", fontSize: 20, color: C.ink,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            zIndex: 5,
          }}
        >›</div>
      )}
    </div>
  );
};

export default function ReviewsPage() {
  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes sunnySparkle {
          0%, 100% { transform: translateX(0) rotate(0deg) scaleX(1); }
          10% { transform: translateX(-8px) rotate(-5deg) scaleX(1.06); }
          20% { transform: translateX(8px) rotate(5deg) scaleX(0.94); }
          30% { transform: translateX(-6px) rotate(-4deg) scaleX(1.05); }
          40% { transform: translateX(6px) rotate(4deg) scaleX(0.95); }
          50% { transform: translateX(-4px) rotate(-3deg) scaleX(1.04); }
          60% { transform: translateX(4px) rotate(3deg) scaleX(0.96); }
          70% { transform: translateX(-3px) rotate(-2deg) scaleX(1.02); }
          80% { transform: translateX(3px) rotate(2deg) scaleX(0.98); }
          90% { transform: translateX(-1px) rotate(-1deg) scaleX(1.01); }
        }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
        button:active { transform: scale(0.98); }
      `}</style>

      <Nav />

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, ${C.yellowSoft} 100%)`,
        padding: "36px 24px 28px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={28} tag="h1">What Parents Say</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 15, color: C.ink + "aa",
            lineHeight: 1.6, margin: "8px auto 16px", maxWidth: 440,
          }}>
            Don't just take our word for it. Here's what families think of The Funky Bunch.
          </p>

          {/* Star rating */}
          <div style={{ marginTop: 4 }}>
            <div style={{ fontSize: 24, color: C.yellow, marginBottom: 2 }}>
              {"★".repeat(5)}
            </div>
            <div style={{ fontFamily: heading, fontWeight: 800, fontSize: 20, color: C.ink }}>
              5.0
            </div>
            <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "77" }}>
              from {reviews.length} reviews
            </div>
          </div>
        </div>
      </section>

      {/* Carousel section */}
      <section style={{ padding: "32px 24px 48px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <ReviewCarousel />
        </div>
      </section>

      {/* Leave a review prompt */}
      <section style={{ padding: "0 24px 48px" }}>
        <div style={{
          maxWidth: 500, margin: "0 auto",
          background: C.yellowSoft, borderRadius: 24,
          border: `2px solid ${C.yellow}30`,
          padding: "28px", textAlign: "center",
        }}>
          <RainbowHeading size={20}>Enjoyed a class?</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 14, color: C.ink + "99",
            lineHeight: 1.6, margin: "8px 0 20px",
          }}>
            We'd love to hear from you! Leave us a review and let other parents know what The Funky Bunch is all about.
          </p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
            <a href="https://www.facebook.com/thefunkybunchkent/reviews/" target="_blank" rel="noopener noreferrer" style={{
              background: "#fff", color: C.ink,
              border: `2px solid ${C.blue}44`,
              padding: "10px 22px", borderRadius: 50,
              fontFamily: heading, fontWeight: 700, fontSize: 13,
              cursor: "pointer", textDecoration: "none",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              Review on Facebook
            </a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
        background: `linear-gradient(135deg, ${C.pinkSoft}, ${C.lilacSoft}, ${C.blueSoft})`,
        padding: "48px 24px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22}>Ready to join the fun?</RainbowHeading>
          <p style={{ fontFamily: body, fontSize: 14, color: C.ink + "99", margin: "8px 0 24px" }}>
            Spaces are limited to 15 children per class. Book your spot today!
          </p>
          <button style={{
            background: C.pink, color: "#fff", border: "none",
            padding: "14px 36px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 16, cursor: "pointer",
          }} onClick={() => { window.location.hash = "classes"; }}>Book a Class</button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
